export default {
    // Every variant: the toast is centred in a row that spans the screen with a
    // 16px gutter and cannot exceed it — on a phone a long message wraps
    // instead of running off the edge.
    // Default variant (current style)
    //-------------------------------------------------------------------------
    default: {
      container: "fixed top-4 inset-x-0 px-4 flex justify-center pointer-events-none",
      notification: "relative pointer-events-auto max-w-full bg-primary text-white p-4 rounded shadow-lg flex items-start md:items-center gap-2",
      message: "text-white min-w-0 break-words",
      closeButton: "ml-2 shrink-0 text-white focus:outline-none hover:text-neutral_2",
    },

    // Success variant
    //-------------------------------------------------------------------------
    success: {
      container: "fixed top-4 inset-x-0 px-4 flex justify-center pointer-events-none",
      notification: "relative pointer-events-auto max-w-full bg-success text-white p-4 rounded shadow-lg flex items-start md:items-center gap-2",
      message: "text-white min-w-0 break-words",
      closeButton: "ml-2 shrink-0 text-white focus:outline-none hover:text-neutral_2",
    },

    // Error variant
    //-------------------------------------------------------------------------
    error: {
      container: "fixed top-4 inset-x-0 px-4 flex justify-center pointer-events-none",
      notification: "relative pointer-events-auto max-w-full bg-error text-white p-4 rounded shadow-lg flex items-start md:items-center gap-2",
      message: "text-white min-w-0 break-words",
      closeButton: "ml-2 shrink-0 text-white focus:outline-none hover:text-neutral_2",
    },

    // Admin variant
    //-------------------------------------------------------------------------
    admin: {
        container: "fixed top-4 inset-x-0 px-4 flex justify-center pointer-events-none",
        notification: "relative pointer-events-auto max-w-full bg-admin_primary text-white p-4 rounded shadow-lg flex items-start md:items-center gap-2",
        message: "text-white min-w-0 break-words",
        closeButton: "ml-2 shrink-0 text-white focus:outline-none hover:text-admin_neutral_2",
    },
  }